// File: noviopus-ats-client/src/features/Job/api.ts
import { internalApi } from '@/utils/request';
import { JobDraft } from './types';

const BASE_URL = '/business/jobs'; 
const REF_URL = '/business/reference';

export const estimateJobTokenCost = async (payload: any) => {
    const res = await internalApi.post('/business/billing/estimate', payload);
    return res.data;
};

export const createJob = async (data: JobDraft) => {
  const response = await internalApi.post(BASE_URL, data);
  return response.data || response;
};

export const updateJob = async (jobId: string, data: JobDraft) => {
  const response = await internalApi.patch(`${BASE_URL}/${jobId}`, data);
  return response.data || response;
};

export const fetchJob = async (jobId: string) => {
    const response = await internalApi.get(`${BASE_URL}/${jobId}`);
    return response.data || response;
};

export const checkJobLimitApi = async (companyId: string) => {
    const response = await internalApi.get(`${BASE_URL}/check-limit`, { params: { companyId } });
    return response.data || response;
};

export const deleteJob = async (jobId: string) => {
    const response = await internalApi.delete(`${BASE_URL}/${jobId}`);
    return response.data || response;
};

export const parseJobDescriptionApi = async (description: string) => {
  const response = await internalApi.post(`${BASE_URL}/parse-jd-preflight`, { rawText: description });
  return response.data || response;
};

// --- DICTIONARIES (V3) ---

export const searchJobTitles = async (search: string) => {
  const response = await internalApi.get(`${REF_URL}/job-titles`, { params: { search } });
  return response.data || response;
};

export const searchSkills = async (search: string) => {
  const response = await internalApi.get(`${REF_URL}/skills`, { params: { search } });
  return response.data || response;
};

export const searchDegrees = async (search: string) => {
  const response = await internalApi.get(`${REF_URL}/degrees`, { params: { search } });
  return response.data || response;
};

export const searchFieldsOfStudy = async (search: string) => {
  const response = await internalApi.get(`${REF_URL}/fields-of-study`, { params: { search } });
  return response.data || response;
};

export const searchLanguages = async (search: string) => {
  const response = await internalApi.get(`${REF_URL}/languages`, { params: { search } });
  return response.data || response;
};